var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 18.8954 0.895431 18 2 18C3.10457 18 4 18.8954 4 20V36H0V20Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2V36H6V2Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 10.8954 16 12V36H12V12Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16C18 14.8954 18.8954 14 20 14C21.1046 14 22 14.8954 22 16V36H18V16Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 6C24 4.89543 24.8954 4 26 4C27.1046 4 28 4.89543 28 6V36H24V6Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22C30 20.8954 30.8954 20 32 20C33.1046 20 34 20.8954 34 22V36H30V22Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 12C36 10.8954 36.8954 10 38 10C39.1046 10 40 10.8954 40 12V36H36V12Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 16C42 14.8954 42.8954 14 44 14C45.1046 14 46 14.8954 46 16V36H42V16Z",
    fill: "#00B8D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon2.7053d88ba51ca7a3f2b3b89a67fd913b.svg";
export { ForwardRef as ReactComponent };